var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('header',{staticClass:"page-title"},[_c('h2',[_vm._v(_vm._s(_vm.data.name))])]),_vm._v(" "),_c('meta-tags-card',{attrs:{"data-card-instance-id":_vm.data.id,"data-card-meta-seo-box":_vm.data.seoBox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }